import * as xmlUtils from '../utils/xml';
import {normalize} from '../utils/array';
import sectionDecoder from './decoders/section_decoder';

export default (rawXML, availability) => new Geometry(rawXML, availability).sections();

function reduceTemplate (acc, el) {
  if (el.template === 'true') {
    acc[el.id] = el
  }
  return acc
}

class Geometry {

  constructor (rawXML, availability) {
    this.parsedXml = xmlUtils.parseXML(rawXML);
    this.availability = availability;

    if (this.parsedXml instanceof Error || xmlUtils.isParsedError(this.parsedXml)) {
      return new Error('MNX Geometry parser - Error parsing the raw xml file. Might be an invalid XML.');
    }

    this.data = {
      page:         xmlUtils.extract(this.parsedXml, 'page'),
      sections:     xmlUtils.extract(this.parsedXml, 'section'),
      polygons:     xmlUtils.extract(this.parsedXml, 'polygon'),
      labels:       xmlUtils.extract(this.parsedXml, 'text'),
      composites:   xmlUtils.extract(this.parsedXml, 'composite')
    };
  }

  sections () {
    const templates = this._getTemplates()

    return this.data.sections
      .filter(section => section.template !== 'true')
      .map(section => this._findRelatedSectionData(section, templates))
      .filter(section => !!section)
      .map(info => sectionDecoder(info, this.availability))
      .filter(section => !!section);
  }

  _mergeWithTemplate(item, templates, type) {
    const itemTemplate = templates[type] && templates[type][item.like]
        ? templates[type][item.like]
        : {};
    return Object.assign({}, itemTemplate, item);
  }

  _getLinkedItem (type, key, value, templates) {
    const items = normalize(this.data[type]);
    const item = items.filter(i => i[key] === value)[0];
    if (!item) return item
    return this._mergeWithTemplate(item, templates, type)
  }

  _getTemplates () {
    return {
      labels: normalize(this.data.labels).reduce(reduceTemplate, {}),
      sections: normalize(this.data.sections).reduce(reduceTemplate, {}),
      polygons: normalize(this.data.polygon).reduce(reduceTemplate, {}),
    }
  }

  _findRelatedSectionData (rawSection, templates) {
    const polygon       = this._getLinkedItem('polygons', 'id', rawSection.lp, templates);
    const composite     = this._getLinkedItem('composites', 'id', rawSection.composite, templates);
    const label         = this._getLinkedItem('labels', 'lp', rawSection.lp, templates);
    const section       = this._mergeWithTemplate(rawSection, templates, 'sections')

    return { section, polygon, composite, label };
  }

}



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/src/index.js